import React from 'react'
let img = "";
const Info = function info ({film,seeing,see,pending}){
    return (
        <section className="sectionList sectionListRamdom">
            <div className='row rowOne'>
                <div className='col s12 m3 l3'>

                </div>
                {film.map((l)=>{
                    if(l.img){
                        img = l.img;
                    }else{
                        img = 'img/not_image.jpeg'
                    }
                    return (
                        <div className='col s12 m6 l6' key={l.id}>
                            <div className='element' style={{
                                backgroundImage: `url("`+img+`")`
                                }}>
                                <div className='back'>
                                </div>
                                <div className='name'>
                                    <h6>
                                        {l.name} <br/>
                                        <span>{l.type}</span>
                                    </h6>
                                </div>
                                <div className='status'>
                                    <h6>
                                        {l.status}
                                    </h6>
                                </div>
                                <div className='info'>
                                    <a className="waves-effect waves-light btn" onClick={()=>pending(l.id)}>
                                        Pendiente
                                    </a>
                                    <a className="waves-effect waves-light btn" onClick={()=>seeing(l.id)}>
                                        Viendo
                                    </a>
                                    <a className="waves-effect waves-light btn btnsee" onClick={()=>see(l.id)}>
                                        Visto
                                    </a>
                                </div>
                            </div>
                        </div>
                    )
                })}
            </div> 
        </section>
    )
}

export default Info
